<template>
  <div class="form-page">
    <!-- Apple Global Header (Sub-nav ribbon hidden on form page) -->
    <AppleNav :show-sub-nav="false" />

    <main class="form-content">
      <MultiStepForm />
    </main>
  </div>
</template>

<script>
import AppleNav from '@/components/AppleNav.vue';
import MultiStepForm from '@/components/MultiStepForm.vue';

export default {
  name: 'FormView',
  components: {
    AppleNav,
    MultiStepForm
  }
}
</script>

<style scoped>
.form-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
}

.form-content {
  flex: 1;
  padding-top: 44px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
